( function($) { 
	// console.log('load me' );
	$( '.uk-modal-close-default' ).on( 'click', function(e) {     
		$( ".gform_fields li.frm-msg" ).html( '' );
		
		e.preventDefault();
	} );

	$( document ).on( 'keyup', function(e) {
		if( e.which === 27 ) {
			$( ".gform_fields li.frm-msg" ).html( '' );
				
			e.preventDefault();
		}
	} );

	$( document ).ready( function() {
		/***phone number format***/
		$( "#input_12" ).keypress( function (e) {
			if( e.which !== 8 && e.which !== 0 && ( e.which < 48 || e.which > 57 ) ) {
				return false;
			}
		} );
	} );

	$( function () {
   	$( 'form.jotform-form' ).on( 'submit', function(e) {
			e.preventDefault();

			var filenameval = $( 'input[type=file]' ).val().toLowerCase();
			var formdata 		= new FormData( $( "#212514371885256" ).get(0) );

			$( '.raq-form-submission-loader-container' ).removeAttr( 'hidden' );
			
			// Display location alert if a store hasn't been selected
			if( $( '#input_24' ).val() === '' || $( '#input_25' ).val() === '' ) {
				$( '.raq-form-submission-loader-container' ).attr( 'hidden', true );
				$( '.form-location-alert-container' ).removeAttr( 'hidden' );
				
				return false;
			}			

			else {
				$( '.form-location-alert-container' ).hide();
			}

			// Make sure consent is checked
      if( $( '#input_20_0' ).is( ':checked' ) ) {
				$( '#input_20_0' ).css( { 'border-color': '#c2c2c2' } );
      }
			
			else {
				$( '.raq-form-submission-loader-container' ).attr( 'hidden', true );
				$( '#input_20_0' ).css( { 'border-color': 'red' } );
				
				return false;
      }      

      if( filenameval !== "" ) {
				regexfile = new RegExp( "(.*?)\.(docx|doc|pdf|xml|jpg|png|ppt|xls)$" );
         
				if( !( regexfile.test( filenameval ) ) ) {
					$( '.raq-form-submission-loader-container' ).attr( 'hidden', true );
					$( ".gformfile span.error" ).html( 'Please select correct file format' );
					
					return false;
				}
				
				else {
					$( ".gformfile span.error" ).html( '' );
				}
      }
			
			else {
				$( ".gformfile span.error" ).html( '' );
      }
      
      $( '#input_7' ).attr( 'disabled', 'disabled' );
      
			// Test form without actually submitting
			// setTimeout( () => {
			// 	$( '.raq-form-submission-loader-container' ).attr( 'hidden', true );
			// 	$( '.frm-msg' ).css( "display", "block" );
			// 	return false;
			// }, 3000 );

			$.ajax( {
				type: 'post',
				url: 'https://submit.jotform.com/submit/212514371885256/',
				data: formdata,
				processData: false,
				contentType: false,
				
				success: function() {
					dataLayer.push( {
						'event': 'rfq-submission',
					} );
					
					$( '.raq-form-submission-loader-container' ).hide();
					$( '.frm-msg' ).css( "display", "block" );
					$( "form.jotform-form input" ).val( '' );
					$( "form.jotform-form #input_20_0" ).prop( 'checked', false );
					$( 'form.jotform-form textarea' ).val( '' ).empty();
					$( 'form.jotform-form .filenameform span' ).html( '' );

					$( '#input_7' ).removeAttr( 'disabled' );
				},

				error: function(e) {
					console.log(e);
				}
      } );

			return false;
		} );
	} );
} )( jQuery );
